import { AutogenLayoutBrokerRatingDetail } from "./autogen/AutogenLayoutBrokerRatingDetail";

export class BrokerRatingDetail extends AutogenLayoutBrokerRatingDetail {

}